export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ02.55878b29.mp3";